import { useEffect, useState, useRef } from "react";
import useOnClickOutside from "../../hooks/useClickOutside";
import chevronDown from "../../assets/vw/svg/chevron-down.svg";
import chevronUp from "../../assets/vw/svg/chevron-up.svg";

// Comportamiento del DropdownSearch
// El DropdownSearch se compone de un input y dos listas de elementos
// Una que es la original y la otra es la filtrada
// Las listas son renderizadas condicionalmente basada isOptionsOpen y isSearching
// Cada elemento se compone de un label y un boton que le permite seleccionarlo

const DropdownSearch = (
    {
        defaultValue,
        menu,
        disabled = false,
        extraStyle = "",
        title,
        handleOptionSelected,
        fieldID,
        fieldToShow
    }
) => {
    const [isOptionsOpen, setIsOptionsOpen] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const menuRef = useRef(null);
    const selectedOption = useRef(null);
    const inputRef = useRef(null);
    const optionsRef = useRef([]);
    const dropdownSearchRef = useRef(null);

    const [searchInput, setSearchInput] = useState("");
    const [menuFiltrado, setMenuFiltrado] = useState([]);

    useOnClickOutside(dropdownSearchRef, () => {
        setIsOptionsOpen(false);
        if (selectedOption.current) {
            setSearchInput(selectedOption.current[fieldToShow]);
        } else {
            setSearchInput("");
        }
    });

    useEffect(() => {
        if (defaultValue) {
            let elemento = menu.find((item) => item[fieldID] === defaultValue || item[fieldToShow] === defaultValue);
            if (elemento) {
                setSearchInput(elemento[fieldToShow]);
                selectedOption.current = elemento;
            }
        }else {
            setSearchInput("");
            selectedOption.current = null;
        }
    }, [defaultValue]);

    const handleOnChangeInput = (e) => {
        let value = e.target.value;
        setSearchInput(value);
        setIsSearching(true);
        if (value && value !== "") {
            let menuFiltrado = menu.filter((item) => item[fieldToShow].toLowerCase().includes(value.toLowerCase()));
            setMenuFiltrado(menuFiltrado);
            // setSelectedOption(null);
        } else {
            setMenuFiltrado([]);
            setIsSearching(false);
            menuRef.current.scrollTop = 0;
            cleanOptionSelected();
        }
    }

    const cleanOptionSelected = () => {
        let event = {
            props: {
                value: "",
                children: ""
            }
        }
        handleOptionSelected(event);
        if (selectedOption.current) {
            cleanOptionSelectedInList(selectedOption);
            selectedOption.current = null;
        }
    }

    const toggleOptions = () => {
        setIsOptionsOpen(prevState => {
            if (inputRef && inputRef.current !== null) {
                if (prevState === true) {
                    inputRef.current.blur();
                } else {
                    inputRef.current.focus();
                }
            }
            return !prevState;
        });
        setIsSearching(false);
        if (selectedOption.current && !isOptionsOpen) {
            goToElement(selectedOption.current[fieldID]);
        }
    };

    const onclickOptionSelected = (option) => {
        cleanOptionSelectedInList(selectedOption);

        activeOptionVisually(option[fieldID]);
        selectedOption.current = option;
        setSearchInput(option[fieldToShow]);
        setIsOptionsOpen(false);
        let event = {
            props: {
                value: option[fieldID],
                children: option[fieldToShow]
            }
        }
        handleOptionSelected(event);
    };

    const handleClickInput = () => {
        setIsOptionsOpen(true);
        setIsSearching(false);

        if (selectedOption.current && !isOptionsOpen) {
            goToElement(selectedOption.current[fieldID]);
        }
    }

    const cleanOptionSelectedInList = () => {
        if (selectedOption.current) {
            deactiveOptionVisually(selectedOption.current[fieldID]);
        }
    }

    const activeOptionVisually = (id) => {
        const elemento = optionsRef.current[id];
        if (elemento) {
            elemento.classList.add("active");
        }
    }

    const deactiveOptionVisually = (id) => {
        const elemento = optionsRef.current[id];
        if (elemento) {
            elemento.classList.remove("active");
        }
    }

    const goToElement = (id) => {
        const elemento = optionsRef.current[id];
        if (elemento) {
            elemento.scrollIntoView({ behavior: 'instant', block: 'center' });
            activeOptionVisually(id);
        }
    }

    return (
        <div ref={dropdownSearchRef} className={`dropdown_vw_input dropdown-search p-0 ${extraStyle !== "" ? extraStyle : ""}`}>
            <div
                className={`containerMenu d-flex align-items-center justify-content-between ${disabled ? "disabled_option" : ""}`}
                style={{
                    padding: ".375rem 0 .375rem 10px"
                }}
            >
                <div className={`content`}>
                    <label
                        className={selectedOption.current || isOptionsOpen ? "title active" : "title"}
                    >{title}</label>
                    <Input
                        title={title}
                        handleClick={handleClickInput}
                        inputRef={inputRef}
                        onChange={handleOnChangeInput}
                        inputValue={searchInput}
                    />
                </div>
                <div className="d-flex btn-arrow-container">
                    <button
                        type="button"
                        style={{
                            backgroundColor: 'transparent',
                            border: 'transparent',
                            bottom: '5%'
                        }}
                        onClick={() => {
                            toggleOptions();
                        }}
                    >
                        {isOptionsOpen === false ? <img src={chevronUp} alt="before" /> : <img src={chevronDown} alt="before" />}
                    </button>
                </div>
            </div>
            <ul
                className={`dropdown-search-list`}
                ref={menuRef}
                style={
                    {
                        visibility: isOptionsOpen && !isSearching ? 'visible' : 'hidden',
                    }
                }
            >
                {
                    menu.map((option, index) => {
                        return (
                            <Opcion
                                key={index}
                                option={option}
                                onclickOptionSelected={onclickOptionSelected}
                                optionsRef={optionsRef}
                                fieldID={fieldID}
                                fieldToShow={fieldToShow}
                            />
                        );
                    })
                }
            </ul>
            <ul
                className={`dropdown-search-list`}
                style={
                    {
                        visibility: isOptionsOpen && isSearching ? 'visible' : 'hidden',
                    }
                }
            >
                {
                    menuFiltrado.length > 0 ? menuFiltrado.map((option, index) => {
                        return (
                            <Opcion
                                key={index}
                                option={option}
                                onclickOptionSelected={onclickOptionSelected}
                                fieldID={fieldID}
                                fieldToShow={fieldToShow}
                            />
                        );
                    }) : (
                        <li
                            style={{
                                padding: '10px'
                            }}
                        >
                            <label className="px-1">No se encontraron resultados</label>
                        </li>
                    )
                }
            </ul>
        </div>
    )
}

const Input = ({
    title,
    handleClick,
    inputRef,
    onChange,
    validationFunction = null,
    inputValue
}) => {

    const [val, setVal] = useState(inputValue ? inputValue : "");

    useEffect(() => {
        setVal(inputValue ? inputValue : "");
    }, [inputValue]);

    const handleOnChangeInput = (e) => {
        let pass = validationFunction ? validationFunction(e) : true;

        if (pass) {
            setVal(e.target.value);
            onChange(e);
        }

    };

    return (
        <input
            ref={inputRef}
            type="text"
            value={val}
            className="form-control-input"
            onClick={handleClick}
            // onBlur={() => {
            //     setIsOptionsOpen(false);
            // }}
            onChange={handleOnChangeInput}
        />
    )
}

const Opcion = ({ option, onclickOptionSelected, optionsRef = null, fieldID, fieldToShow }) => {
    return (
        <li
            id={`opcion-${option[fieldID]}`}
            onClick={() => {
                if (option["disabled"]) {
                    return;
                }
                onclickOptionSelected(option);
            }}
            className={`option ${option["disabled"] ? "disabled" : ""}`}
            ref={ref => {
                if (optionsRef) {
                    optionsRef.current[option[fieldID]] = ref
                }
            }}
        >
            <label>{option[fieldToShow]}</label>
        </li>
    );
}

export default DropdownSearch;